import React, { useState } from "react";
import "./ModalIntro.css";
import { FormattedMessage } from "react-intl";
import { Col, Row } from "react-bootstrap";
import GuideTemplate from "./GuideTemplate";

interface ModalProps {
  closeModal: () => void;
  selectedLanguage: "es" | "en" | "pt"; // Specify the valid language values
}

const ModalIntro: React.FC<ModalProps> = ({ closeModal, selectedLanguage }) => {
  const [step, setStep] = useState<number>(1);

  const languageImages = {
    es: "img/modalwelcome.png",
    en: "img/modalintrohello.png",
    pt: "img/modalintroola.png",
  };

  const handleNext = () => {
    setStep((prevStep) => prevStep + 1);
  };

  const handleExit = () => {
    closeModal();
  };

  const handleBegin = () => {
    closeModal();
  };

  const handleDotClick = (newStep: number) => {
    setStep(newStep);
  };

  /* IMG 1 */
  const imgSrc1 = "img/upperclothingimg.png";
  const paragraphText1 = (
    <FormattedMessage
      id="size-guide-upper-clothing"
      defaultMessage="Prendas Superiores"
    />
  );
  /* IMG 2 */
  const imgSrc2 = "img/bottomwear.png";
  const paragraphText2 = (
    <FormattedMessage
      id="size-guide-lower-clothing"
      defaultMessage="Prendas Inferiores"
    />
  );
  /* IMG 3 */
  // const imgSrc3 = "img/dressimg.png";
  // const paragraphText3 = (
  //   <FormattedMessage
  //     id="size-guide-full-clothing"
  //     defaultMessage="Prendas Enteras"
  //   />
  // );
  /* IMG 4 */
  const imgSrc4 = "img/braimg.png";
  const paragraphText4 = (
    <FormattedMessage id="ready-size-bras" defaultMessage="Sostenes" />
  );
  /* IMG 5 */
  const imgSrc5 = "img/shoeimg2.png";
  const paragraphText5 = (
    <FormattedMessage id="ready-size-footwear" defaultMessage="Calzado" />
  );

  const colStyle = {
    marginBottom: "30px",
  };

  return (
    <div className="modal">
      <div className="modal-intro-container">
        {step === 1 && (
          <div>
            <div className="modal-intro-titles-container">
              <p className="modal-intro-stepone-title">
                <FormattedMessage
                  id="modal-intro-welcome-title"
                  defaultMessage="¡Bienvenidos a ReadySize!"
                />
              </p>
              <img
                src={languageImages[selectedLanguage]}
                alt="welcomeimage"
                className="modalintro-step-one-img"
              />
              <p className="modal-intro-tour">
                <FormattedMessage
                  id="modal-intro-welcome-subtitle"
                  defaultMessage="En el siguiente Tour te mostramos como usar ReadySize para que mejore la experiencia de compra de tus clientes y tus ventas."
                />
                {/* En el siguiente <span className="bold">Tour</span> te mostramos
                como usar <span className="bold">ReadySize</span> para que
                mejore la experiencia de compra de tus clientes y tus ventas. */}
              </p>
            </div>
            <div className="modal-intro-stepzero-buttons-container">
              <button
                className="modal-intro-stepzero-button-bg"
                onClick={handleNext}
              >
                <FormattedMessage
                  id="modal-intro-watch-tour"
                  defaultMessage="Quiero ver el Tour"
                />
              </button>
              <button
                className="modal-intro-stepzero-button-nobg"
                onClick={handleExit}
              >
                <FormattedMessage
                  id="modal-intro-dont-watch"
                  defaultMessage="No gracias"
                />
              </button>
            </div>
          </div>
        )}
        {step === 2 && (
          <div className="modal-intro-titles-container">
            <p className="modal-intro-stepone-title">
              <FormattedMessage
                id="modal-intro-steptwo-title"
                defaultMessage="1. Carga tus Guías de Talles"
              />
            </p>
            <p className="modal-intro-stepone-subtitle">
              <FormattedMessage
                id="modal-intro-steptwo-subtitle"
                defaultMessage="Para poder asociarlas a los productos de tu tienda."
              />
            </p>
            <div className="container-test">
              <p className="modal-intro-stepone-clothing-type">
                <FormattedMessage
                  id="ready-size-clothing-type"
                  defaultMessage="Tipo de prenda:"
                />
              </p>
              <Row className="modalintro-templateguides-container">
                <Col md={6} xl={6} style={colStyle}>
                  <GuideTemplate
                    imgSrc={imgSrc1}
                    paragraphText={paragraphText1}
                    mainContainerClass="modal-intro-guide-template-main-container"
                    imageContainerClass="modal-intro-guide-template-imagecontainer"
                    imageClass="modal-intro-guide-temaplate-image"
                    textContainerClass="modal-intro-guide-template-textcontainer"
                    textClass="modal-intro-guide-template-text"
                  />
                </Col>

                <Col md={6} xl={6} style={colStyle}>
                  <GuideTemplate
                    imgSrc={imgSrc2}
                    paragraphText={paragraphText2}
                    mainContainerClass="modal-intro-guide-template-main-container"
                    imageContainerClass="modal-intro-guide-template-imagecontainer"
                    imageClass="modal-intro-guide-temaplate-image"
                    textContainerClass="modal-intro-guide-template-textcontainer"
                    textClass="modal-intro-guide-template-text"
                  />
                </Col>

                <Col md={6} xl={6} style={colStyle}>
                  <GuideTemplate
                    imgSrc={imgSrc4}
                    paragraphText={paragraphText4}
                    mainContainerClass="modal-intro-guide-template-main-container"
                    imageContainerClass="modal-intro-guide-template-imagecontainer"
                    imageClass="modal-intro-guide-temaplate-image"
                    textContainerClass="modal-intro-guide-template-textcontainer"
                    textClass="modal-intro-guide-template-text"
                  />
                </Col>

                <Col md={6} xl={6} style={colStyle}>
                  <GuideTemplate
                    imgSrc={imgSrc5}
                    paragraphText={paragraphText5}
                    mainContainerClass="modal-intro-guide-template-main-container"
                    imageContainerClass="modal-intro-guide-template-imagecontainer"
                    imageClass="modal-intro-guide-temaplate-image"
                    textContainerClass="modal-intro-guide-template-textcontainer"
                    textClass="modal-intro-guide-template-text"
                  />
                </Col>
              </Row>

              <p className="modal-intro-stepone-clothing-type">
                <FormattedMessage
                  id="modal-intro-steptwo-configure"
                  defaultMessage="Configurar Talles:"
                />
              </p>
              <div className="modalintro-step-two-guidetemplate-main-container">
                <div>
                  <p className="modalintro-steptwo-sizes">
                    <FormattedMessage
                      id="ready-size-sizes"
                      defaultMessage="Talles"
                    />
                    {/* Talles */}
                  </p>
                  <img
                    src="img/introsizesimage1.png"
                    alt="clothinggrid"
                    className="modal-intro-stepone-clothing-grid-img"
                  />
                </div>
                <div>
                  <p className="modalintro-steptwo-bra">
                    <FormattedMessage
                      id="edit-size-guide-contornoBusto"
                      defaultMessage="Contorno de Buso"
                    />
                    {/* Contorno de Buso */}
                  </p>
                  <img
                    src="img/introsizesimage2.png"
                    alt="clothinggrid"
                    className="modal-intro-stepone-clothing-grid-img"
                  />
                </div>
                <div>
                  <p className="modalintro-steptwo-waist">
                    <FormattedMessage
                      id="edit-size-guide-contornoCintura"
                      defaultMessage="Contorno de Cintura"
                    />
                    {/* Contorno de Cintura */}
                  </p>
                  <img
                    src="img/introsizesimage2.png"
                    alt="clothinggrid"
                    className="modal-intro-stepone-clothing-grid-img"
                  />
                </div>
              </div>
              <div className="modalintro-steptwo-measures-titles-container"></div>
            </div>
            <div className="modal-intro-stepone-button-container">
              <button className="modal-intro-button-nobg" onClick={handleExit}>
                <FormattedMessage
                  id="ready-size-close"
                  defaultMessage="Salir"
                />
              </button>
              <div className="modal-intro-dots">
                <span
                  className={step === 2 ? "active-dot" : "dot"}
                  onClick={() => handleDotClick(2)}
                ></span>
                <span className="dot" onClick={() => handleDotClick(3)}></span>
                <span className="dot" onClick={() => handleDotClick(4)}></span>
              </div>
              <button className="modal-intro-button-bg" onClick={handleNext}>
                <FormattedMessage
                  id="readysize-next"
                  defaultMessage="Siguiente"
                />
              </button>
            </div>
          </div>
        )}
        {step === 3 && (
          <div className="modal-intro-titles-container">
            <p className="modal-intro-stepone-title">
              <FormattedMessage
                id="modal-intro-stepthree-title"
                defaultMessage="2. Carga tus Productos"
              />
            </p>
            <p className="modal-intro-stepone-subtitle">
              <FormattedMessage
                id="modal-intro-stepthree-subtitle"
                defaultMessage="Ingresa tus Productos, puede ser manualmente o de forma masiva
                (con un excel o por API)."
              />
            </p>
            <div className="mondalintro-step-three-image-container">
              <div className="mondalintro-step-three-subcontainer">
                <img
                  src="img/individual.png"
                  alt="productloadingimg"
                  className="modal-intro-step-three-img"
                />
                <p>
                  <FormattedMessage
                    id="modal-intro-individual-load"
                    defaultMessage="Carga individual manual (Plantilla)"
                  />
                </p>
              </div>
              <div className="mondalintro-step-three-subcontainer">
                <img
                  src="img/excel.png"
                  alt="productloadingimg"
                  className="modal-intro-step-three-img"
                />
                <p>
                  <FormattedMessage
                    id="modal-intro-massive-load"
                    defaultMessage="Carga masiva por archivo (Excel)"
                  />
                </p>
              </div>
              <div className="mondalintro-step-three-subcontainer">
                <img
                  src="img/api.png"
                  alt="productloadingimg"
                  className="modal-intro-step-three-img"
                />
                <p>
                  <FormattedMessage
                    id="modal-intro-auto-load"
                    defaultMessage="Carga automatizada (API)"
                  />
                </p>
              </div>
            </div>
            {/* <img
              src="img/introproductloadimg.png"
              alt="productloadingimg"
              className="modal-intro-step-three-img"
            /> */}
            <p className="modal-intro-stepone-clothing-type-step-three">
              <FormattedMessage
                id="modal-intro-stepthree-products"
                defaultMessage="Productos:"
              />
            </p>
            <div className="modalintro-step-three-table-img-container">
              <div className="modalintro-step-three-table-content-container">
                <div className="modalintro-step-three-table-p-helper-container">
                  <p className="modalintro-step-three-table-p">
                    <FormattedMessage
                      id="ready-size-code"
                      defaultMessage="Código"
                    />
                  </p>
                  <img
                    src="img/helper.png"
                    alt="helper"
                    className="modalintro-step-three-table-helper"
                  />
                </div>
                <img src="img/table1.png" alt="table" className="" />
              </div>
              <div className="">
                <p className="modalintro-step-three-table-p">
                  <FormattedMessage
                    id="ready-size-alias"
                    defaultMessage="Alias"
                  />
                </p>
                <img src="img/table2.png" alt="table" className="" />
              </div>
              <div className="">
                <p className="modalintro-step-three-table-p">
                  <FormattedMessage
                    id="ready-size-description"
                    defaultMessage="Descripción"
                  />
                </p>
                <img src="img/table3.png" alt="table" className="" />
              </div>
            </div>
            {/* <img src="img/inputsimg.png" alt="inputsimage" /> */}
            <div className="modal-intro-stepone-button-container-stepthree">
              <button className="modal-intro-button-nobg" onClick={handleExit}>
                <FormattedMessage
                  id="ready-size-close"
                  defaultMessage="Salir"
                />
              </button>
              <div className="modal-intro-dots">
                <span className="dot" onClick={() => handleDotClick(2)}></span>
                <span
                  className={step === 3 ? "active-dot" : "dot"}
                  onClick={() => handleDotClick(3)}
                ></span>
                <span className="dot" onClick={() => handleDotClick(4)}></span>
              </div>
              <button className="modal-intro-button-bg" onClick={handleNext}>
                <FormattedMessage
                  id="readysize-next"
                  defaultMessage="Siguiente"
                />
              </button>
            </div>
          </div>
        )}
        {step === 4 && (
          <div className="modal-intro-titles-container">
            <p className="modal-intro-stepone-title">
              <FormattedMessage
                id="modal-intro-stepfour-title"
                defaultMessage="3. Asocia productos con guías"
              />
            </p>
            <p className="modal-intro-stepone-subtitle">
              <FormattedMessage
                id="modal-intro-stepfour-subtitle"
                defaultMessage="Asocia tus Productos a las Guías de Talles que generaste antes."
              />
            </p>
            <div className="modalintro-step-four-container">
              <div>
                <img
                  src="img/modalintrorightclothes.png"
                  alt="table"
                  className=""
                />
              </div>
              <div className="modalintro-step-four-guide-template">
                <img
                  src="img/modalintroclothes.png"
                  alt="table"
                  className="modalintro-step-four-topclothing-image"
                />
                <p className="modalintro-step-four-topclothing-p">
                  {" "}
                  <FormattedMessage
                    id="size-guide-upper-clothing"
                    defaultMessage="Prendas Superiores"
                  />
                </p>
              </div>
            </div>
            {/* <img
              src="img/associatemodalimages.png"
              alt="associatemodalimages"
              className="modal-intro-stepfour-img"
            /> */}
            <p className="modal-intro-stepfour-ready">
              <FormattedMessage
                id="modal-intro-stepfour-ready"
                defaultMessage="¡Listo! ya puedes empezar a usar Fitprenda."
              />
            </p>
            <div className="modal-intro-stepone-button-container-stepfour">
              <button className="modal-intro-button-nobg" onClick={handleBegin}>
                <FormattedMessage
                  id="ready-size-close"
                  defaultMessage="Salir"
                />
              </button>
              <div className="modal-intro-dots">
                <span className="dot" onClick={() => handleDotClick(2)}></span>
                <span className="dot" onClick={() => handleDotClick(3)}></span>
                <span
                  className={step === 4 ? "active-dot" : "dot"}
                  onClick={() => handleDotClick(4)}
                ></span>
              </div>
              <button className="modal-intro-button-bg" onClick={handleExit}>
                <FormattedMessage
                  id="ready-size-begin"
                  defaultMessage="Empezar"
                />
              </button>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default ModalIntro;
